import { Routes, Route, useLocation } from "react-router-dom";
import Home from "../pages/Home";
import About from "../pages/About";
import Contact from "../pages/Contact";
import ResidentParcelDashboard from "../pages/ResidentParcelDashboard";
import Footer from "../components/Footer/Footer";
import SignInForm from "../components/Auth/SignInForm";
import SignUpForm from "../components/Auth/SignUpForm";
import ProtectedRoute from "./ProtectedRoute";
import NotificationPage from "../components/Accounts/NotificationPage";
import ManageAccount from "../components/Accounts/ManageAccount";
import PreApproveBrands from "../components/Accounts/Pre-ApproveBrands";
import FAQ from "../components/Settings/FAQ";
import HowToUse from "../components/Settings/HowToUse";
import Support from "../components/Settings/Support";
import TermsAndConditions from "../components/Settings/TermsAndConditions";
import { useRef } from "react";
import Feedback from "../components/Settings/Feedback";
import DeliveryDashboard from "../pages/DeliveryDashboard";
import PendingDelivery from "../components/DeliveryFlow/Menu/PendingDelivery";
import DeliveryHistory from "../components/DeliveryFlow/Menu/DeliveryHistory";
import DeliveryHowToUse from "../components/DeliveryFlow/Menu/DeliveryHowToUse";
import DeliverySupport from "../components/DeliveryFlow/Menu/DeliverySupport";
import SubscriptionPage from "../components/Accounts/SubscriptionPage";
import PaymentHistory from "../components/Accounts/PaymentHistory";
import DeliveryManageAccount from "../components/DeliveryFlow/Menu/DeliveryManageAccount";
import PrivacyPolicy from "../components/Settings/PrivacyPolicy";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

function AppRoutes() {
  const location = useLocation();

  const aboutRef = useRef(null);
  const contactRef = useRef(null);

  const handleScrollToAbout = () => {
    const el = document.getElementById("about-section");
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  const handleScrollToContact = () => {
    const el = document.getElementById("contact-section");
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  // const hideFooterPaths = [
  //   "/delivery-dashboard",
  //   "/delivery-dashboard/pendingdelivery",
  //   "/delivery-dashboard/deliveryhistory",
  //   "/delivery-dashboard/howtouse",
  //   "/delivery-dashboard/faq",
  //   "/delivery-dashboard/support",
  //   "/delivery-dashboard/termsandconditions",
  //   "/delivery-dashboard/privacypolicy",
  //   "/delivery-dashboard/deliverymanageaccount",
  // ];
  // const showFooter = !hideFooterPaths.includes(location.pathname);

  const showFooter = location.pathname === "/";

  return (
    <>
      <Routes>
        <Route
          path="/"
          element={<Home aboutRef={aboutRef} contactRef={contactRef} />}
        />

        {/* ✅ Protected Routes for Resident */}
        <Route element={<ProtectedRoute allowedRoles={["resident"]} />}>
          <Route
            path="/resident-parcel-dashboard"
            element={<ResidentParcelDashboard />}
          />
          <Route
            path="/resident-parcel-dashboard/notification"
            element={<NotificationPage />}
          />
          <Route
            path="/resident-parcel-dashboard/manage-account"
            element={<ManageAccount />}
          />
          <Route
            path="/resident-parcel-dashboard/pre-approvebrands"
            element={<PreApproveBrands />}
          />
          <Route path="/resident-parcel-dashboard/faq" element={<FAQ />} />
          <Route
            path="/resident-parcel-dashboard/howtouse"
            element={<HowToUse />}
          />
          <Route
            path="/resident-parcel-dashboard/support"
            element={<Support />}
          />
          <Route
            path="/resident-parcel-dashboard/TermsAndConditions"
            element={<TermsAndConditions />}
          />
          <Route
            path="/resident-parcel-dashboard/PrivacyPolicy"
            element={<PrivacyPolicy />}
          />
          <Route
            path="/resident-parcel-dashboard/feedback"
            element={<Feedback />}
          />
          <Route
            path="/resident-parcel-dashboard/subscription"
            element={<SubscriptionPage />}
          />
          <Route
            path="/resident-parcel-dashboard/paymenthistory"
            element={<PaymentHistory />}
          />
        </Route>

        {/* ✅ Protected Route for Delivery */}
        <Route element={<ProtectedRoute allowedRoles={["delivery"]} />}>
          <Route path="/delivery-dashboard" element={<DeliveryDashboard />} />
          <Route
            path="/delivery-dashboard/pendingdelivery"
            element={<PendingDelivery />}
          />
          <Route
            path="/delivery-dashboard/deliverymanageaccount"
            element={<DeliveryManageAccount />}
          />

          <Route
            path="/delivery-dashboard/deliveryhistory"
            element={<DeliveryHistory />}
          />
          <Route
            path="/delivery-dashboard/howtouse"
            element={<DeliveryHowToUse />}
          />

          <Route path="/delivery-dashboard/faq" element={<FAQ />} />

          <Route
            path="/delivery-dashboard/support"
            element={<DeliverySupport />}
          />
          <Route
            path="/delivery-dashboard/termsandconditions"
            element={<TermsAndConditions />}
          />

          <Route
            path="/delivery-dashboard/privacypolicy"
            element={<PrivacyPolicy />}
          />
        </Route>
        {/* <Route path="/delivery-dashboard" element={<DeliveryDashboard />} /> */}

        {/* Public Routes */}
        <Route path="/about" element={<About />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/signin" element={<SignInForm />} />
        <Route path="/signup" element={<SignUpForm />} />
      </Routes>

      {/* ToastContainer - Global, visible on all pages */}
      <ToastContainer
        position="top-right"
        autoClose={4000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
        toastStyle={{
          color: "#14AE5C",
          fontWeight: "600",
          borderRadius: "12px",
          padding: "16px 20px",
          boxShadow: "0 10px 25px rgba(59, 130, 246, 0.3)",
          border: "1px solid rgba(255, 255, 255, 0.2)",
        }}
        progressStyle={{
          background: "rgba(255, 255, 255, 0.4)",
          height: "4px",
        }}
        bodyStyle={{
          fontFamily: "'Inter', 'Segoe UI', sans-serif",
        }}
      />

      {showFooter && (
        <Footer
          onAboutClick={handleScrollToAbout}
          onContactClick={handleScrollToContact}
        />
      )}
    </>
  );
}

export default AppRoutes;
